import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const Operator = lazy(() =>
    import('@/v1/setting/views/Operator').then((module) => ({
        default: module.Operator,
    }))
);
const Terminus = lazy(() =>
    import('@/v1/setting/views/Terminus').then((module) => ({
        default: module.Terminus,
    }))
);
const Vehicle = lazy(() =>
    import('@/v1/setting/views/Vehicle').then((module) => ({
        default: module.Vehicle,
    }))
);
const Merchant = lazy(() =>
    import('@/v1/setting/views/Merchant').then((module) => ({
        default: module.Merchant,
    }))
);

export const basicSettingRoutes: RouteObject[] = [
    {
        path: `operator`,
        ...PageElement(<Operator />),
    },
    {
        path: `terminus`,
        ...PageElement(<Terminus />),
    },
    {
        path: `vehicle`,
        ...PageElement(<Vehicle />),
    },
    {
        path: `merchant`,
        ...PageElement(<Merchant />),
    },
];
